import { Card } from '@moojo/card-definition-catalog'
import { endpointDeclaration } from '@moojo/endpoints'
import { z } from 'zod'

// TODO(imaman): We should restrict this - should every app be able to contribute data? I think not
/**
 * User is identified by a bearer token (Authorization header)
 */
export const ContributeToProfileRequest = z.discriminatedUnion('kind', [
  z.object({
    kind: z.literal('update'),
    cards: Card.array(),
  }),
  z.object({
    // TODO(imaman): We should restrict this - not every app should be able to wipe out
    kind: z.literal('wipeOut'),
  }),
  z.object({
    kind: z.literal('narratively'),
    freeText: z.string(),
  }),
  z.object({
    kind: z.literal('refreshTargetingTags'),
  }),
])

export type ContributeToProfileRequest = z.infer<typeof ContributeToProfileRequest>

export const ContributeToProfileResponse = z.record(z.string(), z.never())

export type ContributeToProfileResponse = z.infer<typeof ContributeToProfileResponse>

export const contributeToProfileDeclaration = endpointDeclaration(
  ContributeToProfileRequest,
  ContributeToProfileResponse,
)
